import {ieFix} from './utils/ie-fix';
import {iosVhFix} from './utils/ios-vh-fix';
import {userAgent} from './utils/user-agent';

import {cardNomination} from './modules/card-nomination';
import {addMenuListeners} from './modules/menu';
import {addScrollLinkListener} from './modules/scroll-link';
import {initSliders} from './modules/works-slider';
import {addFoldingBlockListener} from './modules/folding-block';
import {addNominationListener} from './modules/nomination';
import {addCopyTagsListener} from './modules/copy-tags';

// Utils
// ---------------------------------

ieFix();
iosVhFix();
userAgent();

// Modules
// ---------------------------------

addMenuListeners();
addScrollLinkListener();
addFoldingBlockListener();
addNominationListener();
addCopyTagsListener();
cardNomination();
initSliders();
